import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useStore } from "../../store/globalState";
import { AuraLayout, Layout, AddCardIcon } from "lola-framework-ui-test";

import { FlowHeroMark } from "../../components/FlowHeroMark";

/**
 * Gallery-safe m2m "Adding card" processing screen.
 *
 * Production tokenizes the card via VGS, registers it through the API and
 * auto-navigates on success. Here it is a pure visual: the processing
 * animation with a caption, so the screen can be inspected on its own with no
 * network, redirects or side effects.
 */
export const AddCardProcessingPage = memo(() => {
  const { t } = useTranslation("m2m");
  const { theme } = useStore();
  const colorConfig = theme.whiteView;
  const { backgroundBtn, textColorBtn, dropzoneColors } = colorConfig;

  return (
    <AuraLayout colorConfig={colorConfig} className="white-view-background flavor-a">
      <Layout.Content className="loading-section sending-money-section">
        <section className="sending-money-container">
          <FlowHeroMark
            showSpinner
            dropzoneColors={dropzoneColors}
            backgroundIcon={backgroundBtn}
          >
            <AddCardIcon
              size={60}
              colors={[textColorBtn, textColorBtn]}
              className="flavor-c-icon"
            />
          </FlowHeroMark>
          <section className="sending-caption">
            <h1 className="foreground highlight text-centered">
              {t("card.addingCard", { defaultValue: "Adding card" })}
              <span className="span-block lola-title-h1 h1">
                {t("card.pleaseWait", { defaultValue: "Please wait..." })}
              </span>
            </h1>
          </section>
        </section>
      </Layout.Content>
    </AuraLayout>
  );
});
